export const COLOR_PALETTE_SIZE = 15;
export const GRID_SIZE = 16;
export const WIDTH = 4.0;
